import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { MAX_MASTERY_COUNT } from '../../../../constants';

const TableSkeleton = () => {
  return (
    <div className='overflow-x-auto relative'>
      <table className='w-full text-xs sm:text-sm md:text-base lg:text-lg text-left text-gray-500 dark:text-gray-400'>
        <thead className='text-xs sm:text-sm md:text-base lg:text-lg text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400'>
          <tr>
            <th scope='col' className='py-3 px-2 sm:px-4 md:px-6 text-left'>
              <Skeleton width={100} />
            </th>
            {Array.from({ length: MAX_MASTERY_COUNT }, (_, idx) => (
              <th scope='col' className='text-center py-3 px-2 sm:px-4 md:px-6' key={idx}>
                <Skeleton width={100} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 10 }, (_, index) => (
            <tr key={index} className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
              <td className='py-4 px-2 sm:px-4 md:px-6 text-left'>
                <Skeleton />
              </td>
              {Array.from({ length: MAX_MASTERY_COUNT }, (_, idx) => (
                <td className='py-4 px-2 sm:px-4 md:px-6 text-center' key={idx}>
                  <Skeleton />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;
